import MockAdapter from 'axios-mock-adapter'

import { Brand } from '../../modules/brand/model'

export enum MockType {
  SERVICE = 'SERVICE',
  MODEL = 'MODEL',
}

export enum Tag {
  MANY_ACCOUNTS = 'MANY_ACCOUNTS',
  SINGLE_ACCOUNT = 'SINGLE_ACCOUNT',
  TWO_ACCOUNTS = 'TWO_ACCOUNTS',
  HAS_COMPATIBLE_BONUSES = 'HAS_COMPATIBLE_BONUSES',
  IS_PREPAID = 'IS_PREPAID',
  IS_ACTIVATED = 'IS_ACTIVATED',
  IS_NOT_ACTIVATED = 'IS_NOT_ACTIVATED',
  IS_GROUP_ONFLY = 'IS_GROUP_ONFLY',
  IS_BUSINESS = 'BUSINESS',
  IS_TARIFF_MOBILE = 'IS_MOBILE',
  STANDARD = 'STANDARD',
  ALL_TARIFFS_MOBILE = 'ALL_TARIFFS_MOBILE',
  HAS_THREE_ELE = 'HAS_THREE_ELE',
  HAS_TWO_ELE = 'HAS_TWO_ELE',
  HAS_0_ELE = 'AS_0_ELE',
  HAS_TARIFF_MOBILE = 'HAS_TARIFF_MOBILE',
  HAS_TARIFF_CONVERGENT_WITH_ADDITIONALS = 'HAS_TARIFF_CONVERGENT_WITH_ADDITIONALS',
  IS_FIBER = 'IS_FIBER',
  HAS_BALANCE = 'HAS_BALANCE',
  HAS_BONUSES = 'HAS_BONUSES',
  HAS_PROMOTIONS = 'HAS_PROMOTIONS',
  HAS_CONSUMPTIONS = 'HAS_CONSUMPTIONS',
  HAS_BARRINGS = 'HAS_BARRINGS',
  HAS_SERVICES = 'HAS_SERVICES',
  IN_ACCOUNT_WITH_MANY_PACKAGES = 'IN_ACCOUNT_WITH_MANY_PACKAGES',
  IN_ACCOUNT_WITH_1_PACKAGE = 'IN_ACCOUNT_WITH_1_PACKAGE',
  HAS_PERMISSION_CUSTOMER = 'HAS_PERMISSION_CUSTOMER',
  HAS_PERMISSION_PRODUCT = 'HAS_PERMISSION_PRODUCT',
  HAS_PERMISSION_RECHARGES = 'HAS_PERMISSION_RECHARGES',
  HAS_PERMISSION_OFFERS_CONFIGURATOR = 'HAS_PERMISSION_OFFERS_CONFIGURATOR',
  HAS_NO_PERMISSIONS = 'HAS_NO_PERMISSIONS',
  HAS_ENERGY_CONTRACTS = 'HAS_ENERGY_CONTRACTS',
  HAS_0_ENERGY_CONTRACTS = 'HAS_0_ENERGY_CONTRACTS',
}

export interface CustomerInfoMock {
  mockType: 'CustomerInfoMock'
  nameId: string
  id: string
  identificationNr?: string
  fileName?: string
  parentId?: string
  parentNameId?: string
  accountNumber?: string
  type: MockType
  brand?: Brand
  tags: Tag[]
  addInterceptor?: (mockAdapter: MockAdapter) => void
  ele?: unknown
}

export interface AgentInfoMock {
  mockType: 'AgentInfoMock'
  nameId: string
  type: MockType
  brand: Brand
  tags: Tag[]
  sub: string
  familyName: string
  givenName: string
  addInterceptor?: (mockAdapter: MockAdapter) => void
}

export interface EnergyContractInfoMock {
  mockType: 'EnergyContractInfoMock'
  nameId: string
  type: MockType
  brand: Brand
  tags: Tag[]
  addInterceptor?: (MockAdapter: MockAdapter) => void
}
export interface MockDB {
  [key: string]: CustomerInfoMock | AgentInfoMock | EnergyContractInfoMock
}
